import { PublicClientApplication } from '@azure/msal-browser';

// Placeholder Azure AD / Entra ID config — replace with real values in Phase 3
const msalConfig = {
  auth: {
    clientId: 'placeholder-client-id',
    authority: 'https://login.microsoftonline.com/placeholder-tenant-id',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

// Login request scopes — extend in Phase 3
export const loginRequest = {
  scopes: ['User.Read'],
};

export const msalInstance = new PublicClientApplication(msalConfig);
